import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { Warning } from '../volkswagen.types';

@Component({
  selector: 'app-vw-warning',
  standalone: true,
  template: `
    <div class="relative my-3 max-w-2xl rounded-lg border border-red-200 bg-red-50 py-4 pl-10 pr-4">
      <i class="pi pi-exclamation-triangle absolute left-3 top-4 text-2xl text-red-600"></i>

      <div class="-mt-2">
        <!-- Children will be rendered here -->
        <ng-template #childrenContainer></ng-template>
      </div>
    </div>
  `,
})
export class WarningComponent extends XMLElementBaseComponent<Warning> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef }) childrenContainer!: ViewContainerRef;
  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  ngAfterViewInit() {
    if (this.data?.children) {
      this.childRenderService.setProvider(this.provider);
      this.childComponents = this.childRenderService.renderChildren(this.data.children, this.childrenContainer);
    }
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
